import Navbar from './components/Navbar';
import Hero from './components/Hero';
import WhatIs from './components/WhatIs';
import Categories from './components/Categories';
import Articles from './components/Articles';
import CTA from './components/CTA';
import Footer from './components/Footer';

export default function Home() {
  return (
    <div className="min-h-screen flex flex-col">
      <Navbar />
      <main className="flex-1">
        <Hero />
        <WhatIs />
        <Categories />
        <Articles />
        <CTA />
      </main>
      <Footer />
    </div>
  );
}